module.exports = __webpack_public_path__ + "img/flex8.3efa3ac7.gif";